// extracted by mini-css-extract-plugin
export default {"questionsBlock":"Block_questionsBlock__wp90Q"};